export default __webpack_public_path__ + "static/media/catflix-profiles.290f2fba.png";